import { isSwedenCountryNameOrUndefined } from 'tradera-localization/countrycode';

export const selectViewItem = state => state.views.viewItem;

export const selectTranslatedDescription = state =>
    state.views.viewItem.translatedDescription || null;

export const selectItemDetails = state => selectViewItem(state).itemDetails;

export const selectBreadcrumbs = state => selectViewItem(state).breadCrumbs;

export const selectItemId = state => selectItemDetails(state)?.itemId;

export const selectBidInfo = state => selectViewItem(state).bidInfo;

export const selectAllowedBuyerRegionOutsideSweden = state =>
    selectItemDetails(state)?.allowedBuyerRegion &&
    !isSwedenCountryNameOrUndefined(
        selectItemDetails(state).allowedBuyerRegion
    );

export const selectTranslatedDescriptionState = state =>
    selectViewItem(state).translatedDescriptionState;
